var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavbarLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 123 16",
    width: 123,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.99128 2.44833h-1.99128v11.12457h1.99128v-4.55576h5.99503v-1.99183h-5.99503zm7.98631 13.11647h-7.98631v-1.9919h7.98631zm0-13.11647h-7.98631v-1.991838h7.98631z",
    fill: "#0b0c0d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.0665 15.5648h2.0124v-13.43432h5.0418v-1.695177h-12.096v1.695177h5.0418z",
    fill: "#0b0c0d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m24.7988 15.5648h2.0125v-6.92907h7.9651v6.92907h2.0125v-15.129497h-2.0125v6.505247h-7.9651v-6.505247h-2.0125z",
    fill: "#0b0c0d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m47.4556.435303-1.6667 2.499997-1.6666-2.499997z",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m45.7889 7.27741-.4248.65789.4248.6579.4249-.6579z",
    fill: "#000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m45.7889 5.63267-1.5359 2.30263 1.5359 2.3026 1.536-2.3026zm0 .6579-1.0784 1.64473 1.0784 1.64474 1.0785-1.64474z",
    fill: "#000",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m43.5994 7.9353 2.1895-3.28947 2.1896 3.28947-2.1896 3.2895z",
    fill: "#000",
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m47.4556 5.4353 1.6667-2.5h-3.3334-3.3333l1.6667 2.5h-3.3334l1.6667 2.5-1.6667 2.5h3.3334l-1.6667 2.5h3.3333l-1.6666 2.5h3.3333l-1.6667-2.5h3.3334l-1.6667-2.5h3.3333l-1.6666-2.5 1.6666-2.5zm0 0-1.6667-2.5-1.6666 2.5-1.6667 2.5 1.6667 2.5 1.6666 2.5 1.6667-2.5 1.6667-2.5z",
    fill: "#000",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0b0c0d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64.7665 13.5729v1.9919h-7.9863v-1.9919zm-9.9776-13.116407h1.9913v13.116407h-1.9913z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.7495 2.44833v-1.991837h3.9825v1.991837zm0 1.99183h-1.9913v-1.99183h1.9913zm7.9651 0v11.12464h-1.9913v-4.5558h-7.9651v4.5558h-1.9913v-11.12464h1.9913v4.57698h7.9651v-4.57698zm-3.9826 0v-1.99183h1.9913v1.99183z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.7987 15.5648h2.0124v-13.43432h5.0418v-1.695177h-12.096v1.695177h5.0418z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.8569 2.44833v-1.991837h3.9821v1.991837zm0 1.99183h-1.9913v-1.99183h1.9913zm7.9651 0v11.12464h-1.991v-4.5558h-7.9654v4.5558h-1.9912v-11.12464h1.9912v4.57698h7.9654v-4.57698zm-3.983 0v-1.99183h1.992v1.99183z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.517 15.5648h1.906v-12.58673h.043l4.724 12.58673h1.716l4.724-12.58673h.042v12.58673h1.906v-15.129497h-2.753l-4.788 12.713797-4.766-12.713797h-2.754z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarLogo);
export default __webpack_public_path__ + "static/media/navbar-logo.c8cccdd6248544d7850a1bbcfd8d1e5c.svg";
export { ForwardRef as ReactComponent };